import { Component } from "vue";
import { DSIconAppearance } from "@/src/design_system/primitives/icon/types";
import { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import iconStore from "@/src/design_system/primitives/icon/store/iconStore";

export const getSvgComponentLoader = (svgName: DSIconName, appearance: DSIconAppearance): Component | null => {
  return iconStore.getIconComponent(svgName, appearance);
};
